import { COVERGO_SAAS_DEV } from "../consts.js"

export const chdr_dev = {
	"chdr-studio.dev.asia.covergo.cloud": {
		appConfig: {
			tenantId: "chdr_dev",
			appId: "covergo_crm"
		},
		envConfig: COVERGO_SAAS_DEV,
		fileSystem: {
			bucketName: "covergo-apse1-dev-chdr-dev"
		}
	}
}


